import { marked } from "marked";
import { useMemo } from "react";

// Lightweight markdown renderer for transcription summaries.
// Uses `marked` with inline-only mode for list previews and
// full mode for detail views.

marked.setOptions({
  gfm: true,
  breaks: true,
});

interface MarkdownProps {
  source: string;
  className?: string;
  inline?: boolean;
}

export function Markdown({ source, className = "", inline = false }: MarkdownProps) {
  const html = useMemo(() => {
    const trimmed = source.trim();
    if (!trimmed) return "";
    if (inline) {
      // Strip block-level wrappers for one-line previews
      const parsed = marked.parseInline(trimmed) as string;
      return parsed;
    }
    return marked.parse(trimmed) as string;
  }, [source, inline]);

  if (!html) return null;

  return (
    <span
      className={`md ${inline ? "md-inline" : "md-block"} ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
